import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterEvent} from '@angular/router';
import {Store} from '@ngrx/store';
import {AppState} from 'src/app/store/app.state';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  constructor(private _router: Router, private _store: Store<AppState>) {

    this._router.events.subscribe((event: RouterEvent) => {
      switch (true) {
        case event instanceof NavigationStart:
          this.loader = true;
          break;

        case event instanceof NavigationEnd:
          this.loader = false;
          break;

        case event instanceof NavigationCancel:
          this.loader = false;
          break;

        case event instanceof NavigationError:
          this.loader = false;
          break;

        default:
          break;
      }
    });

    // network disconnection and reconnection
    window.setInterval(() => {
      const reconnectInterval: number = this.reconnectInterval[AppComponent.randomIntFromInterval(0, 3)];
      const networkStatus = navigator.onLine;
      if (!networkStatus) {
        this.networkDisconnections += 1;
        this.networkStatus = networkStatus;
      }
      if (networkStatus && (this.networkDisconnections > 0)) {
        this.networkFeedback.reconnect = true;
        if (AppComponent.networkDivId) {
          AppComponent.networkDivId.classList.remove('network-disconnect');
          AppComponent.networkDivId.classList.add('network-reconnect');
        }
        this.networkFeedback.message = 'Reconnecting';
        setTimeout(() => {
          this.networkStatus = networkStatus;
          this.networkFeedback.message = 'Network disconnected!';
          this.networkFeedback.reconnect = false;
          if (AppComponent.networkDivId) {
            AppComponent.networkDivId.classList.remove('network-reconnect');
            AppComponent.networkDivId.classList.add('network-disconnect');
          }

        }, reconnectInterval);
      }
    }, 5000);

    // console welcome message
    console.log('%c WELCOME TO EDMS', 'color: brown; font-weight: bold; font-size: 48px');
    console.log('IP ', window.location.host);
  }

  static networkDivId = document.getElementById('networkStat');
  title = 'Welcome to EDMS';
  public loader: boolean;
  private loaderSub: Subscription;

  public networkStatus = true;
  public networkFeedback = {
    reconnect: false,
    message: 'Network disconnected!'
  };
  public networkDisconnections = 0;
  public reconnectInterval: number[] = [2000, 3000, 4000, 5000];

  /**
   *
   * @param min
   * @param max
   */
  private static randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  ngOnInit(): void {
    this.loaderSub = this._store.select('loader').subscribe(value => {
      this.loader = value.loaderState;
    });
  }

  ngAfterViewInit(): void {

  }

  ngOnDestroy(): void {
    this.loaderSub.unsubscribe();
  }
}
